import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const deleteIframe = (iframeId: number) => {
  return axiosPrivate.delete(`/dashboard/api/v1/iframes/${iframeId}`);
};
